import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import sidemenucss from "../../css/sidemenu.module.css";
import commoncss from "../../css/common.module.css";
import { useDispatch, useSelector } from "react-redux";
// import { ReactComponent as BaseCorp } from "../../assets/icons/base-corp.svg";

import { ReactComponent as Plus } from "../../../myfin_v2/assets/icons/plusBlack.svg";

const PopulateFSSideMenu = ({
  menuItems,
  subMenu,
  title,
  titleClassName,
  subTitle,
  activeCat,
  setActiveCat,
  setSubMenuId,
  showNotesDetails,
  redirectNote,
  setRedirectNote,
  subMenuId,
  subgroupId,
  setSubGroupId,
}) => {
  const dispatch = useDispatch();

  const routerHistory = useHistory();

  useEffect(() => {
    if (redirectNote && subMenu) {
      setSubMenuId(redirectNote);
      showNotesDetails(redirectNote);
      setRedirectNote(null);
    }
  }, [subMenu]);

  // Auto-scroll to active submenu item
  useEffect(() => {
    if (subMenuId) {
      const timer = setTimeout(() => {
        const el = document.getElementById("side-consol-" + subMenuId);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "nearest" });
        }
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [subMenuId]);
  return (
    <div
      className={`${sidemenucss.sidemenuContainer} ${sidemenucss.sidemenuBackgroundClr}`}
    >
      <div
        className={sidemenucss.sidemenuHeader}
        style={{ "minHeight": "15vh" }}
      >
        <span className={`${sidemenucss.sidemenuTitle} ${titleClassName || ""}`}>{title}</span>
        <span className={`${sidemenucss.sidemenuSubTitle} ${sidemenucss.customSideMenu}`}>{subTitle}</span> 
      </div>
      <div
        className={`${sidemenucss.sidemenuContent} ${sidemenucss.sidemenuLinksFontSize} ${sidemenucss.sidemenuContentTop} ${commoncss.hideScroll} pt-0`}
      >
        <ul className={sidemenucss.sidemenuList}>
          {menuItems.map((item, index) => (
            <div key={index}>
              <li
                className={`${sidemenucss.sidemenuItem} ${
                  activeCat === item.value ? sidemenucss.sidemenuItemActive : ""
                }`}
                onClick={() => {
                  setActiveCat(item.value);
                }}
              >
                <span className={sidemenucss.sidemenuItemname}>
                  <div className={sidemenucss.sideMenuItemContainer}>
                    {item.label}
                  </div>
                </span>
              </li>
              {subMenu &&
                subMenu?.category === item.value &&
                subMenu?.submenu && (
                  <div className={sidemenucss.submenuContainer}>
                    {subMenu.submenu.map((item, idx) => (
                      <div key={idx} id={"side-consol-" + item.value}>
                        <div
                          className={`${sidemenucss.submenuItem} ${
                            subMenuId === item.value
                              ? sidemenucss.activeSubMenu
                              : null
                          }`}
                          onClick={() => {
                            showNotesDetails(item.value);
                            setSubMenuId(item.value);
                          }}
                        >
                          {item.label}
                        </div>
                        {subMenuId === item.value && (item.subGroup || item.subgroup) && (
                          <div style={{ paddingLeft: "15px", paddingBottom: "10px", fontSize: "12px", borderLeft: "1px solid #eee", marginLeft: "5px" }}>
                            {(item.subGroup || item.subgroup).filter(sg => (sg.dataType || sg.datatype) === "table").map((sg, sgIdx) => (
                              <div
                                key={sgIdx}
                                style={{ 
                                  padding: "5px 0", 
                                  cursor: "pointer",
                                  color: subgroupId === sg._id ? "#205a46" : "#66827a",
                                  fontWeight: subgroupId === sg._id ? "700" : "400"
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setSubGroupId(sg._id);
                                  const el = document.getElementById(sg._id);
                                  if (el) {
                                    el.scrollIntoView({ behavior: "smooth", block: "start" });
                                  }
                                }}
                              >
                                {sg.tableTitle || sg.particular || `Table ${sgIdx + 1}`}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}
            </div>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default PopulateFSSideMenu;